import { Link, Outlet, useSearchParams } from 'react-router-dom';
import { decomDetailPages, pagesConfig } from '../../../shared/pages-config';
import { useRouteMatch } from '../../../shared/useRouteMatch';
import SimpleBreadcrumbsPage from '../../../shared/simple-breadcrumbs-page';
import { ModuleList } from '../../../shared/analytics/module-list';
import { DecomActionModel, DecomModel } from '../../../../types';

import SharedTabCard from '../../../shared/shared-tab-card';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';

export interface DecomActionDaysModel extends Partial<DecomActionModel> {
  day: number;
}
export interface DecomForm extends DecomModel {
  actionsData?: DecomActionDaysModel[];
  selectedActions?: string[];
}

// Utility type to create the dynamic field names
export type DecomFormField =
  | keyof DecomForm
  | `actionsData.${number}.${keyof DecomActionDaysModel}`;

export default function DecomPage() {
  const [searchParams] = useSearchParams();

  const isFormPage = useRouteMatch([
    `${pagesConfig.decommissioningLayout.link}/${pagesConfig.createDecomPolicyFormPage.link}`,
    `${pagesConfig.decommissioningLayout.link}/${pagesConfig.editDecomPolicyFormPage.link}`,
    `${pagesConfig.decommissioningLayout.link}/${pagesConfig.cloneDecomPolicyFormPage.link}`,
  ]);

  const routeMatch = useRouteMatch([
    `${pagesConfig.decommissioningLayout.link}/${pagesConfig.decomPolicies.link}`,
    `${pagesConfig.decommissioningLayout.link}/${pagesConfig.decomSuspendedUsers.link}`,
    `${pagesConfig.decommissioningLayout.link}/${pagesConfig.decomLogs.link}`,
  ]);

  if (isFormPage) {
    return <Outlet />;
  }

  const currentTab =
    routeMatch?.pattern?.path ?? `${pagesConfig.decomPolicies.link}`;

  return (
    <SimpleBreadcrumbsPage
      breadcrumbs={[
        { label: ModuleList.modules.automation.name },
        { label: pagesConfig.decommissioningLayout.name },
      ]}
      bookmarkKey={pagesConfig.decommissioningLayout.value}
      topContent={
        <SharedTabCard>
          <Tabs
            value={currentTab.split('/').pop()}
            variant="scrollable"
            allowScrollButtonsMobile
            sx={{
              mx: 1,
              '& .MuiTabs-flexContainer': {
                marginTop: '6px',
              },
              '.MuiTabs-scrollButtons.Mui-disabled': {
                opacity: 0.3,
              },
            }}
          >
            {decomDetailPages.map((page) => (
              <Tab
                key={page.name}
                label={page.name}
                value={page.link}
                component={Link}
                to={{
                  pathname: page.link,
                  search: searchParams.toString(),
                }}
                icon={<page.icon />}
                iconPosition="start"
                sx={{ minHeight: '40px', height: '40px' }}
              />
            ))}
          </Tabs>
        </SharedTabCard>
      }
      heightOfTopContent={58}
      isSubTabs
    >
      <Outlet />
    </SimpleBreadcrumbsPage>
  );
}
